import { render, staticRenderFns } from "./PersonsList.vue?vue&type=template&id=3472edb7&scoped=true&"
import script from "./PersonsList.vue?vue&type=script&lang=js&"
export * from "./PersonsList.vue?vue&type=script&lang=js&"
import style0 from "./PersonsList.vue?vue&type=style&index=0&id=3472edb7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3472edb7",
  null
  
)

export default component.exports